import { useNavigate, useSearchParams } from "react-router-dom";
import VoucherView from "@/pages/VoucherView";
import { useDayBookReturn } from "@/lib/useDayBookReturn";

export default function Vouchers() {
  useDayBookReturn();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const editId = searchParams.get("edit") || "";
  const editType = searchParams.get("type") || "";
  return (
    <VoucherView
      onClose={() => navigate("/dashboard")}
      initialMode={editId ? (editType === "payment" ? "payment" : "receipt") : null}
      editId={editId}
    />
  );
}
